import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm" sx={{ minHeight: '80vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
      <Box sx={{ textAlign: 'center', mt: 0 }}>
        <Typography variant="h1" sx={{ fontWeight: 700, color: 'rgba(203, 68, 34, 0.6)', fontSize: 100 }}>
          404
        </Typography>
        <Typography variant="h5" sx={{ mb: 2, fontWeight: 500, color: '#CB4422' }}>
          Page Not Found
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: '#CB4422' }}>
          Sorry, the page you are looking for does not exist.
        </Typography>
        <Button
          variant="contained"
          sx={{
            textTransform: 'none',
            borderRadius: 2,
            backgroundColor: '#CB4422',
            color: '#fff',
            fontWeight: 600,
            '&:hover': { backgroundColor: '#a62d1f' }
          }}
          onClick={() => navigate('/')}
        >
          Go to Home
        </Button>
      </Box>
    </Container>
  );
};

export default PageNotFound;